import "../sass/main.scss";
import("fslightbox");

const detectViewport = () => {
  let options = {
    // null is to target document viewport
    root: null,
    // bounding box of target element before computing visibility
    rootMargin: "0px",
    // indicates at what percentage of the target's visibility the ovbserver callback should be executed
    threshold: [0.85],
  };

  let callback = (entries, observer) => {
    var delay = 0;
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        setTimeout(function () {
          entry.target.classList.add("active");
        }, delay);

        // increase the delay to allow a cascading effect for the elements
        delay += 125; // in milliseconds

        // stop listening for this element
        observer.unobserve(entry.target);
      }
    });
  };

  // create the intersection observer
  let observer = new IntersectionObserver(callback, options);

  document.querySelectorAll("[anim]").forEach((element) => {
    observer.observe(element);
  });
};

const stickyNav = () => {
  const submenuPanel = document.querySelectorAll("aside.submenu-panel"),
    navItems = document.querySelectorAll(".wp-block-navigation-item.has-child");

  navItems.forEach((target) => {
    submenuPanel.forEach((panel) => {
      if (target.classList.contains(panel.getAttribute("id")))
        target.appendChild(panel);
    });
  });

  // Hide Header on on scroll down
  const outerHeight = (el) => {
    var height = el.offsetHeight;
    var style = window.getComputedStyle(el);
    height += parseInt(style.marginTop) + parseInt(style.marginBottom);
    return height;
  };

  const navBar = document.querySelector(".site-header"),
    navbarHeight = outerHeight(navBar);

  let intervalId,
    didScroll,
    lastScrollTop = 0,
    delta = 5;

  window.addEventListener("scroll", function () {
    didScroll = true;
  });

  const hasScrolled = () => {
    let st = window.scrollY;

    if (st > 200) {
      navBar.classList.add("nav-sticky");
    } else {
      navBar.classList.remove("nav-sticky");
    }

    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - st) <= delta) return;

    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > navbarHeight) {
      // Scroll Down
      navBar.classList.remove("nav-down");
      navBar.classList.add("nav-up");
    } else {
      // Scroll Up
      if (
        st + window.screen.height <
        Math.max(
          document.body.getBoundingClientRect().height,
          document.documentElement.getBoundingClientRect().height
        )
      ) {
        navBar.classList.remove("nav-up");
        navBar.classList.add("nav-down");
      }
    }

    lastScrollTop = st;
  };

  intervalId = setInterval(function () {
    if (didScroll) {
      hasScrolled();
      didScroll = false;
    }
  }, 250);
};

const openModal = () => {
  const jsModalOfferForm = document.querySelector(".js-modal-offer-form"),
    modalOfferForm = document.querySelector(".modal-offer-form"),
    closeModalOfferForm = document.querySelector(".close-modal-offer-form");

  if (modalOfferForm) {
    jsModalOfferForm.addEventListener("click", function (e) {
      e.preventDefault();
      modalOfferForm.classList.add("active");
    });
  }

  if (closeModalOfferForm) {
    closeModalOfferForm.addEventListener("click", function (e) {
      e.preventDefault();
      modalOfferForm.classList.remove("active");
    });
  }
};

const menuMobile = () => {
  const itemMenuHasChild = document.querySelectorAll(
      ".nav-principal.wp-block-navigation.menu-mobile ul.wp-block-navigation__container > .wp-block-navigation-item.has-child > .wp-block-navigation-item__content, .nav-principal.wp-block-navigation.menu-mobile ul.wp-block-navigation__container > .wp-block-navigation-item.has-child > ul.wp-block-navigation__submenu-container > .wp-block-navigation-item.has-child > .wp-block-navigation-item__content"
    ),
    submenus = document.querySelectorAll(
      ".nav-principal.wp-block-navigation.menu-mobile .wp-block-navigation__container > .wp-block-navigation-submenu > .wp-block-navigation__submenu-container"
    ),
    burger = document.querySelector(
      ".nav-principal.wp-block-navigation.menu-mobile .wp-block-navigation__responsive-container-open"
    ),
    closeMenuBurger = document.querySelector(
      ".nav-principal.wp-block-navigation.menu-mobile .wp-block-navigation__responsive-container-close"
    ),
    newEmplacementCloseBurgerMenu = document.querySelector(
      ".nav-principal.wp-block-navigation.menu-mobile"
    );

  // Move close burger menu
  newEmplacementCloseBurgerMenu.appendChild(closeMenuBurger);

  // Click close burger menu
  closeMenuBurger.addEventListener("click", function (e) {
    e.preventDefault();
    document.body.classList.remove("burger-open");
    deleteAllSubmenus();
  });

  // Activate burger menu
  burger.addEventListener("click", function (e) {
    e.preventDefault();
    document.body.classList.toggle("burger-open");
  });

  // Activate each submenu
  itemMenuHasChild.forEach((item) => {
    item.addEventListener("click", function (e) {
      console.log(item);
      const accordions = document.querySelectorAll(
        ".menu-mobile.nav-principal.wp-block-navigation .wp-block-navigation-submenu.accordion > ul.accordion"
      );
      e.preventDefault();
      accordions.forEach((node) => {
        node.classList.remove("active");
      });
      item.parentElement
        .querySelector(".wp-block-navigation__submenu-container")
        .classList.add("active");
    });
  });

  // Add back button into each submenu
  submenus.forEach((item) => {
    const buttonTitle = item.parentElement.querySelector(
      ".wp-block-navigation-item__content"
    ).innerHTML;
    item.insertAdjacentHTML(
      "afterbegin",
      "<li class='wp-block-navigation-item wp-block-navigation-link back-button'><a href='#' class='js-back-button'><span>" +
        buttonTitle +
        "</span></a></li>"
    );

    // Close all submenus
    item
      .querySelector(".js-back-button")
      .addEventListener("click", function (e) {
        e.preventDefault();
        deleteAllSubmenus();
      });
  });

  const deleteAllSubmenus = () => {
    submenus.forEach((node) => {
      node.classList.remove("active");
    });
  };
};

const main = () => {
  //console.log("hello FSE Youdemus theme !!!");
  const siteHeader = document.querySelector(".site-header"),
    jsModalOfferForm = document.querySelector(".js-modal-offer-form");
  if (siteHeader) stickyNav();
  if (siteHeader) menuMobile();
  if (jsModalOfferForm) openModal();

  detectViewport();
  const buttonIsStyleOutline = document.querySelector(
    "button[name='is-style-outline']"
  );
  if (buttonIsStyleOutline) {
    buttonIsStyleOutline.parentElement.classList.add(
      "wp-block-button",
      "is-style-outline"
    );
    buttonIsStyleOutline.classList.add(
      "wp-block-button__link",
      "has-border-color",
      "has-secondary-border-color",
      "wp-element-button"
    );
  }
};

document.addEventListener("DOMContentLoaded", () => {
  
  main();
});
